import React, { useEffect } from "react";
import { AuthCookies } from "../enums/AuthCookies";
import { PdsLoadingPage } from "@principal/design-system-react";
import { useAuth } from "oidc-react";

const Redirector = () => {
    const auth = useAuth()
    const user = auth.userData

    useEffect(() => {
        const redirectUri = sessionStorage.getItem(AuthCookies.REDIRECT_URI);
        if(user && redirectUri) {
            window.location.href = redirectUri
        }
    }, [user])

    return (
        <PdsLoadingPage/>
    )
};
export default Redirector;